module.exports = __webpack_public_path__ + "static/media/travel_and_hospitality.7630f7f1.png";